import React, { Fragment } from 'react';
import Sticky from 'react-stickynode';
import { ThemeProvider } from 'styled-components';
import { charityTheme } from 'common/theme/charity';
import { ResetCSS } from 'common/assets/css/style';
import { DrawerProvider } from 'common/contexts/DrawerContext';
import Navbar from 'containers/Charity/Navbar';
import DrawerSection from 'containers/Charity/DrawerSection';
import BannerSection from 'containers/FloodDefence/BannerSection';
import ManagementPlan from 'containers/FloodDefence/ManagementPlan';
import ManagementStats from 'containers/VisitorDemographics/ManagementStats';
import CurrentDefences from 'containers/FloodDefence/CurrentDefences';
import PlanningPolicy from 'containers/FloodDefence/PlanningPolicy';
import Footer from 'containers/Charity/Footer';
import CTAOne from 'containers/Greenway/CallToActionOne';

import {
  GlobalStyle,
  CharityWrapper,
  ContentWrapper,
} from 'containers/Charity/charity.style';
import Seo from 'components/seo';

const Index = () => {
  return (
    <ThemeProvider theme={charityTheme}>
      <Fragment>
        <Seo
          title="Flood Defence"
          description="Information about how the Lammas Lands acts as a key defence for the town"
        />
        <ResetCSS />
        <GlobalStyle />
        {/* Start charity wrapper section */}
        <CharityWrapper>
          <Sticky top={0} innerZ={9999} activeClass="sticky-nav-active">
            <Navbar />
          </Sticky>
          <DrawerProvider>
            <DrawerSection />
          </DrawerProvider>
          <ContentWrapper>
            <BannerSection />
            <ManagementPlan />
            <ManagementStats />
            <CurrentDefences />
            <PlanningPolicy />
            <CTAOne />
            <Footer />
          </ContentWrapper>
        </CharityWrapper>
        {/* End of charity wrapper section */}
      </Fragment>
    </ThemeProvider>
  );
};
export default Index;
